import 'core-js/modules/es.object.assign.js';
import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';

const CurrentUserContext = /*#__PURE__*/createContext(undefined);
const useCurrentUserContext = () => {
  const context = useContext(CurrentUserContext);
  if (!context) {
    throw new Error('useCurrentUser must be used within a CurrentUserProvider');
  }
  return context;
};
const CurrentUserProvider = ({
  currentUser,
  children
}) => {
  const value = {
    currentUser: currentUser !== null && currentUser !== void 0 ? currentUser : null
  };
  return jsx(CurrentUserContext.Provider, Object.assign({
    value: value
  }, {
    children: children
  }));
};

export { CurrentUserProvider, useCurrentUserContext };
